import { Grid, Tooltip } from '@mui/material';
import { convertTypeToContent } from './util';

type Props = {
    title: string;
    place: string;
    description: string;
}

export const ListEvent = ({ title, place, description }: Props) => {
    return (
        <Tooltip title={description}>
            <Grid container direction="row" justifyContent="space-between">
                <Grid item>{convertTypeToContent(title)}</Grid>
                <Grid item>{place}</Grid>
            </Grid>
        </Tooltip>
    )
}
